// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import type { VariantGenerationAssistantAsyncResult } from "./types";

const nullableStrings = anyOf(arrayOf(string), nullValidation);
const nullableString = anyOf(string, nullValidation);

export const isVariantGenerationAssistantAsyncResult = objectOf<VariantGenerationAssistantAsyncResult>({
  status: number,
  response: maybe(nullableStrings),
  error: maybe(nullableString),
  model: maybe(nullableString),
  error_code: maybe(string),
});
